/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * ---------------------------------------------------------------------------
 * Fix: adding to an EMPTY cart left the cart drawer showing "Your cart is empty"
 * ---------------------------------------------------------------------------
 * section-cart-drawer's _replaceContent() reads:
 *
 *   this.element.querySelector('.CartDrawer__Items').parentNode
 *   this.element.querySelector('.Drawer__Footer').parentNode
 *
 * Those two nodes do not exist in the drawer's empty-cart markup, so the very
 * first line throws "Cannot read properties of null (reading 'parentNode')".
 * The throw happens inside a nested .then(), so the rejection is swallowed and
 * the drawer silently never updates until a full page reload.
 *
 * Once the cart has at least one item the nodes exist and the normal path works,
 * which is why this only ever showed up on the first add to an empty cart.
 *
 * This wrapper detects that state and swaps the drawer's inner HTML wholesale
 * instead. Everything else falls through to the original implementation.
 *
 * To remove this fix, delete everything below this comment block.
 */
(function () {
  var PATCH_FLAG = '__prismEmptyCartDrawerPatch';

  function applyPatch() {
    var el = document.querySelector('section-cart-drawer');
    if (!el) return false;

    var proto = Object.getPrototypeOf(el);
    if (!proto || typeof proto._replaceContent !== 'function') return false;
    if (proto[PATCH_FLAG]) return true;

    var original = proto._replaceContent;

    proto._replaceContent = function (html) {
      var host = this.element || this;
      var missingNodes =
        !host.querySelector('.CartDrawer__Items') ||
        !host.querySelector('.Drawer__Footer') ||
        !host.querySelector('.Form--cart');

      if (missingNodes) {
        try {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('section-cart-drawer') || tmp.firstElementChild;
          if (fresh) {
            host.innerHTML = fresh.innerHTML;
            return;
          }
        } catch (e) {
          console.warn('[Prism] empty-cart drawer swap failed, falling back:', e);
        }
      }

      return original.apply(this, arguments);
    };

    proto[PATCH_FLAG] = true;
    return true;
  }

  if (applyPatch()) return;

  document.addEventListener('DOMContentLoaded', applyPatch);

  // The drawer section can be upgraded after this script runs; retry briefly.
  var attempts = 0;
  var timer = setInterval(function () {
    if (applyPatch() || ++attempts > 40) clearInterval(timer);
  }, 250);
})();

/**
 * ---------------------------------------------------------------------------
 * Prism Perks launcher
 * ---------------------------------------------------------------------------
 * Builds the floating rewards button and keeps it clear of the product page's
 * sticky add-to-cart bar. Styles live in custom.css under the matching
 * heading - remove both together.
 *
 * The label is always in the markup; custom.css hides it below 750px so the
 * button collapses to an icon-only circle on phones.
 */
(function () {
  var LOYALTY_PATH = '/pages/rewards-9a3945';
  var CLASS = 'prism-perks-launcher';
  var LABEL = 'Rewards';

  var ICON =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"' +
    ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
    '<rect x="3" y="11" width="18" height="10" rx="1"></rect>' +
    '<path d="M3 7h18v4H3z"></path>' +
    '<path d="M12 7v14"></path>' +
    '<path d="M12 7S11 3 9 3a2 2 0 0 0 0 4h3z"></path>' +
    '<path d="M12 7s1-4 3-4a2 2 0 0 1 0 4h-3z"></path>' +
    '</svg>';

  function mount() {
    if (!document.body) return;
    if (document.querySelector('.' + CLASS)) return;

    // No point offering a shortcut to the page they are already on.
    if (window.location.pathname.indexOf(LOYALTY_PATH) === 0) return;

    var link = document.createElement('a');
    link.className = CLASS;
    link.href = LOYALTY_PATH;
    link.setAttribute('aria-label', 'Prism Perks rewards');
    link.innerHTML = ICON + '<span class="' + CLASS + '__label">' + LABEL + '</span>';

    document.body.appendChild(link);
  }

  /**
   * On product pages <product-sticky-add-to-cart> is a full-width 112px bar
   * fixed to bottom: 0. It is never removed from the DOM - it slides in and
   * out on a transform - so a static offset would leave the button floating
   * high whenever the bar is retracted.
   *
   * Measure how far the bar actually intrudes and publish it as
   * --prism-perks-lift, which custom.css adds to the bottom offset.
   */
  var PROP = '--prism-perks-lift';
  var BAR = 'product-sticky-add-to-cart';
  var GAP = 12; // breathing room between the button and the bar
  var queued = false;

  function measure() {
    queued = false;

    var bar = document.querySelector(BAR);
    var lift = 0;

    if (bar) {
      var rect = bar.getBoundingClientRect();
      if (rect.height > 0) {
        var intrusion = window.innerHeight - rect.top;
        if (intrusion > 0) {
          lift = Math.min(intrusion, rect.height) + GAP;
        }
      }
    }

    document.documentElement.style.setProperty(PROP, lift + 'px');
  }

  /**
   * rAF is the right throttle for scroll, but it never fires while the tab is
   * hidden - so the first measurement is taken directly rather than queued,
   * otherwise a page that loads in a background tab would have no lift set.
   */
  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(measure);
  }

  function start() {
    mount();
    measure();
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('load', start);

  // The bar animates in and out without any scrolling of its own.
  document.addEventListener(
    'transitionend',
    function (event) {
      if (event.target && event.target.tagName === BAR.toUpperCase()) schedule();
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/**
 * ---------------------------------------------------------------------------
 * Collection filters: instant "loading" feedback (Nov 3, 2026)
 * ---------------------------------------------------------------------------
 * component-filter-product.js waits 500ms after a click before it fetches
 * results, then fires theme:loading:start / theme:loading:end. Add the
 * html.prism-filtering class (styled in custom.css) on click, so the product
 * grid dims right away, and clear it when the new results are in.
 * A safety timer clears it if a request never finishes.
 */
(function () {
  var CLS = 'prism-filtering';
  var root = document.documentElement;
  var timer;

  function start() {
    root.classList.add(CLS);
    clearTimeout(timer);
    timer = setTimeout(stop, 8000);
  }
  function stop() {
    clearTimeout(timer);
    root.classList.remove(CLS);
  }

  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t || !t.closest) return;
    var item = t.closest(
      '.FilterProducts__Form .ProductFilters__Item, [data-tg-action="apply-price"], [data-tg-action="change-sort"]'
    );
    if (!item) return;
    if (item.matches('[data-tg-action="change-sort"].Active')) return; // same sort, no reload
    var input = item.querySelector && item.querySelector('input');
    if (input && input.disabled) return;
    start();
  });

  /**
   * Colour tiles. The Color filter uses grouped values from Search &
   * Discovery, so the theme writes an internal ID into each swatch and can't
   * find the tile image. Use the same tile files the product cards use
   * (Settings > Files, e.g. teal.png). File names are case-sensitive, so the
   * known ones are listed; anything else tries "<name>.png" and is hidden if
   * there's no file and no colour already set.
   */
  var TILES = {
    'amber': 'Amber.png',
    'aqua': 'aqua.jpg',
    'black': 'black.png',
    'blue': 'blue.png',
    'blueberry': 'blueberry.png',
    'bubblegum': 'bubblegum.png',
    'clear': 'clear.png',
    'cloud': 'Cloud.png',
    'coral': 'coral.jpg',
    'gold': 'gold.png',
    'green': 'green.png',
    'key lime': 'key-lime.png',
    'midnight': 'midnight.png',
    'mint': 'mint.png',
    'pink': 'pink-lemonade.png',
    'pink lemonade': 'pink-lemonade.png',
    'purple': 'purple.png',
    'red': 'red.png',
    'sapphire': 'sapphire.png',
    'silver': 'Silver.png',
    'slime': 'slime.png',
    'teal': 'teal.png',
    'tie dye': 'Tie-Dye.jpg',
    'white': 'white.png'
  };
  var FILES = '/cdn/shop/files/';
  function setTile(sw, file) {
    sw.style.backgroundImage = 'url("' + FILES + file + '?width=64")';
    sw.style.backgroundSize = 'cover';
  }
  function paintSwatches() {
    var list = document.querySelectorAll('.FilterProducts__Form .FilterProductsColorSwatch');
    for (var i = 0; i < list.length; i++) {
      var sw = list[i];
      if (sw.dataset.prismPainted) continue;
      sw.dataset.prismPainted = '1';
      var label = sw.closest('label');
      var name = label && label.querySelector('.ProductFilters__ItemLabel');
      var key = name ? name.textContent.trim().toLowerCase() : '';
      if (TILES[key]) {
        setTile(sw, TILES[key]);
        continue;
      }
      var cs = window.getComputedStyle(sw);
      var hasLook = cs.backgroundImage !== 'none' || cs.backgroundColor !== 'rgba(0, 0, 0, 0)';
      var guess = key.replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') + '.png';
      (function (sw, guess, hasLook) {
        var probe = new Image();
        probe.onload = function () { setTile(sw, guess); };
        probe.onerror = function () { if (!hasLook) sw.classList.add('prism-swatch-none'); };
        probe.src = FILES + guess + '?width=64';
      })(sw, guess, hasLook);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paintSwatches);
  } else {
    paintSwatches();
  }

  document.addEventListener('theme:loading:end', function () {
    stop();
    // The theme then overwrites "Now showing 95 items" with a bare "18".
    // Put the wording back once it has done that.
    setTimeout(function () {
      paintSwatches();
      var el = document.querySelector('.CollectionAside__ProductCount');
      if (!el) return;
      var n = el.textContent.trim();
      if (/^\d+$/.test(n)) {
        el.textContent = 'Now showing ' + n + (n === '1' ? ' item' : ' items');
      }
    }, 0);
  });
})();
